import styled from '../../theme/styled-with-theme';
import { mediaQueries } from '../../styles/media-queries';
import { GlImage, GlImageProps } from '../Image';

interface Props extends GlImageProps {
  currentImage: boolean;
}

export const ImageWrapper = styled('div')`
  position: relative;
  width: 100%;
`;

export const StyledImage = styled(GlImage, {
  shouldForwardProp: (prop) => !['currentImage'].includes(prop)
})<Props>`
  max-width: 100%;
  margin: 0 auto;
  flex-grow: 1;
  display: ${({ currentImage }) => (currentImage ? 'block' : 'none')};
  z-index: 0;

  ${mediaQueries.desktop} {
    max-width: 480px;
    margin-right: ${({ theme }) => theme.spacing.m};
  }
`;
